var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"yx-pingfang-semibold",class:_vm.statusObj.styleClass},[_vm._v(_vm._s(_vm.statusObj.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }